<!--
@Author: Kleber Pinel <kleberdasilva>
@Date:   2019-03-01T10:21:35-08:00
@Email:  kleber@hackcapital.com
@Last modified by:   kleberdasilva
@Last modified time: 2019-03-04T14:57:58-08:00
-->

<template lang="pug">
  li.sortable-item
    span.handle(v-handle='')
      v-icon drag_indicator
    slot
    .pin(v-if="pinnable" :class="{ active: pinned }")
      v-tooltip(bottom)
        span(v-if="pinned") Unpin column
        span(v-else) Pin column
        v-btn(small icon @click="togglePin" slot="activator")
          .pin-icon
</template>

<script>
import { ElementMixin, HandleDirective } from 'vue-slicksort';

export default {
  mixins: [ElementMixin],
  directives: { handle: HandleDirective },
  props: {
    item: {
      type: String,
      default: '',
    },
    pinnable: {
      type: Boolean,
      default: false,
    },
    pinned: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    togglePin() {
      this.$emit('pin', !this.pinned);
    },
  },
};

</script>

<style lang="scss" scoped>
  .pin {
    position: absolute;
    right: 10px;
    top: 0px;
    width: 30px;
    height: 30px;
    .v-btn {
      margin: 2px;
      color: var(--v-text-base);
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
    .pin-icon:after {
      background-position: center;
      background-repeat: no-repeat;
      background-image: var(--pin-icon);
      height: 30px;
      width: 30px;
      content: "";
      display: block;
    }
    &.active .pin-icon:after {
      background-image: var(--unpin-icon);
    }
  }
  .sortable-item {
    position: relative;
    --pin-icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+CiAgPHBhdGggZmlsbD0iIzIwMjEyNCIgZD0iTTE3IDR2N2wyIDN2MmgtNnY1bC0xIDEtMS0xdi01SDV2LTJsMi0zVjRjMC0xLjEuOS0yIDItMmg2YzEuMTEgMCAyIC44OSAyIDJ6TTkgNHY3Ljc1TDcuNSAxNGg5TDE1IDExLjc1VjRIOXoiLz4KPC9zdmc+Cg==);
    --unpin-icon: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+CiAgPHBhdGggZmlsbD0iIzIwMjEyNCIgZD0iTTE3IDRhMiAyIDAgMCAwLTItMkg5Yy0xLjEgMC0yIC45LTIgMnY3bC0yIDN2Mmg2djVsMSAxIDEtMXYtNWg2di0ybC0yLTNWNHoiLz4KPC9zdmc+Cg==);
    &.dragging {
      .pin, .active {
        display: block;
        &:after {
          background-position: center;
          background-repeat: no-repeat;
          background-image: var(--pin-icon);
          position: absolute;
          content: "";
          height: 30px;
          width: 30px;
          top: 2px;
          right: -1px;
        }
      }
      .active {
        &:after {
          background-image: var(--unpin-icon);
        }
      }
    }
  }
</style>